export default "__VITE_ASSET__CRgvHdOS__"